import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppelapiService } from './appelapi.service';


@Injectable()
export class IntercepteurHttp implements HttpInterceptor {
    constructor(private api: AppelapiService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        request = request.clone({
            setHeaders: {
                'Content-Type': this.api.ContentType,
                'x-api-key': 'vo6U39MUy331hwaOPzzNw5MT6CUUuoowT7xMxEHa'
            }
        });

        return next.handle(request);
    }
}
